import { render, staticRenderFns } from "./MaterialsDetail.vue?vue&type=template&id=5bc0bb22&scoped=true"
import script from "./MaterialsDetail.vue?vue&type=script&lang=js"
export * from "./MaterialsDetail.vue?vue&type=script&lang=js"
import style0 from "./MaterialsDetail.vue?vue&type=style&index=0&id=5bc0bb22&prod&lang=scss&scoped=true"
import style1 from "./MaterialsDetail.vue?vue&type=style&index=1&id=5bc0bb22&prod&lang=scss"
import style2 from "./MaterialsDetail.vue?vue&type=style&index=2&id=5bc0bb22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc0bb22",
  null
  
)

export default component.exports